// angular
import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { AppService } from '../../../../app.service';
import {
    AUTO_STYLE,
    animate,
    state,
    style,
    transition,
    trigger
} from '@angular/animations';
  
@Component({
    selector: 'me-landing-page-faq',
    templateUrl: './landing-page-faq.component.html',
    styleUrls: ['./landing-page-faq.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: [
        trigger('collapse', [
            state('false', style({ height: AUTO_STYLE, visibility: AUTO_STYLE, paddingBottom: '38px', opacity: 1 })),
            state('true', style({ height: '0', visibility: 'hidden', paddingBottom: '0px', opacity: 0 })),
            transition('false => true', animate('100ms ease-in')),
            transition('true => false', animate('100ms ease-out'))
        ])
    ]
})

export class MeLandingPageFaqComponent {
    @Input() data : any = {};
    expands = [];

    constructor(
        public appService: AppService
    ) {
       
    }

    toggleCollapse(data){
        this.expands[data._uid] = !this.expands[data._uid];
        // let textBody = document.getElementById('accordian-body-' + data._uid);
        // if (textBody) {
        //     textBody.focus();
        // }
    }
}
